import { render, staticRenderFns } from "./addBrandType.vue?vue&type=template&id=9986af96&scoped=true&"
import script from "./addBrandType.vue?vue&type=script&lang=js&"
export * from "./addBrandType.vue?vue&type=script&lang=js&"
import style0 from "./addBrandType.vue?vue&type=style&index=0&id=9986af96&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9986af96",
  null
  
)

export default component.exports